export const memberNetworkNotificationSettingsFields = () => `
    __typename
    enabled
    channel
    isDefault
    mention
    reaction
    sameAsDefault
`
